/* WhiteSpace Cart Gift Card - in-cart UI behavior
 * Pairs with snippets/ws-cart-gift-card.liquid.
 * Strategy: event delegation on document. Idempotent (no double-binding).
 * Single card design, 2 states: offer+message / added-compact.
 * On add/edit, refresh the cart drawer so the snippet re-renders.
 */
(function () {
  if (window.__wsGiftCardBound) return;
  window.__wsGiftCardBound = true;

  var PROP = 'הודעה לכרטיס';

  // While editing, holds the message to restore after the snippet re-renders.
  // Kept until the user saves or cancels, so repeated re-renders (the theme may
  // fire several cart events) never drop the text mid-flight.
  var pendingEditMsg = null;

  function clearPendingEdit() {
    pendingEditMsg = null;
    try { sessionStorage.removeItem('ws_gc_prev_msg'); } catch (e) {}
  }

  function onCartPage() {
    try {
      return (window.themeVariables &&
              window.themeVariables.settings &&
              window.themeVariables.settings.pageType === 'cart');
    } catch (e) { return false; }
  }

  // Re-fetch the cart-drawer section and swap the gift-card snippet in place.
  // Re-renders from the live cart state, so it also resets the card to the
  // offer (collapsed) state when the gift-card line is removed natively.
  // Does NOT dispatch cart events (avoids feedback loops).
  function swapSnippet() {
    return fetch('/?section_id=cart-drawer', { cache: 'no-store' })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-ws-gc]');
        document.querySelectorAll('[data-ws-gc]').forEach(function (live) {
          if (!fresh) {
            if (live.parentNode) live.parentNode.removeChild(live);
          } else {
            live.outerHTML = fresh.outerHTML;
          }
        });
      })
      .catch(function () { /* ignore */ });
  }

  // Refresh the WhiteSpace cart drawer + re-render the gift card snippet.
  function refreshCart() {
    // On the full cart page, the simplest reliable refresh is a reload.
    if (onCartPage()) {
      window.location.reload();
      return;
    }
    // Drawer: ask the theme to re-render its cart UI (cart:refresh triggers
    // _onCartRefresh). The cart-event listener below catches this and swaps our
    // snippet in a single path, avoiding a double-swap race with the message.
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  // Reveal / collapse the message form
  function setOpen(root, open) {
    if (!root) return;
    var form = root.querySelector('[data-ws-gc-form]');
    var openBtn = root.querySelector('[data-ws-gc-open]');
    if (form) form.hidden = !open;
    if (openBtn) openBtn.hidden = open;
    if (open && form) {
      var ta = form.querySelector('[data-ws-gc-textarea]');
      if (ta) {
        try { ta.focus({ preventScroll: true }); } catch (e) { ta.focus(); }
      }
      // Opening the textarea grows the card; in the drawer this can push the
      // submit button below the fold. Scroll it into view so it stays visible.
      var addBtn = form.querySelector('[data-ws-gc-add]');
      var target = addBtn || form;
      if (target && target.scrollIntoView) {
        setTimeout(function () {
          target.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }, 60);
      }
    }
  }

  // Switch the submit button between "add" and edit ("save changes") modes.
  function setAddMode(root, mode) {
    if (!root) return;
    var btn = root.querySelector('[data-ws-gc-form] [data-ws-gc-add]');
    if (!btn) return;
    var txt = btn.querySelector('.ws-gc__btn-text');
    var emoji = btn.querySelector('.ws-gc__btn-emoji');
    if (mode === 'save') {
      if (txt) txt.textContent = 'שמירת השינויים';
      if (emoji) emoji.hidden = true;
    } else {
      if (txt) txt.textContent = 'הוספה לעגלה';
      if (emoji) emoji.hidden = false;
    }
  }

  document.addEventListener('click', function (e) {
    // 0) Open the form (collapsed -> message entry)
    var openBtn = e.target.closest('[data-ws-gc-open]');
    if (openBtn) {
      e.preventDefault();
      var rootO = openBtn.closest('[data-ws-gc]');
      setAddMode(rootO, 'add');
      setOpen(rootO, true);
      return;
    }

    // 1) Add to cart
    var addBtn = e.target.closest('[data-ws-gc-add]');
    if (addBtn) {
      e.preventDefault();
      if (addBtn.disabled) return;
      var root = addBtn.closest('[data-ws-gc]');
      if (!root) return;
      var form = root.querySelector('[data-ws-gc-form]');
      var variantId = form ? parseInt(form.dataset.variantId, 10) : 0;
      if (!variantId) { console.error('[ws-gc] missing variant id'); return; }
      var ta = root.querySelector('[data-ws-gc-textarea]');
      var msg = ta ? (ta.value || '').trim() : '';
      var props = {};
      if (msg) props[PROP] = msg;

      var origLabel = addBtn.textContent;
      addBtn.disabled = true;
      addBtn.textContent = 'מוסיף...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: props }] })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed: ' + r.status);
          return r.json();
        })
        .then(function () { clearPendingEdit(); refreshCart(); })
        .catch(function (err) {
          console.error('[ws-gc] add error', err);
          addBtn.disabled = false;
          addBtn.textContent = origLabel;
          alert('שגיאה בהוספת הכרטיס. נסו שוב.');
        });
      return;
    }

    // 2) Cancel (clear the message field, reset the counter, collapse back)
    var cancelBtn = e.target.closest('[data-ws-gc-cancel]');
    if (cancelBtn) {
      e.preventDefault();
      var rootC = cancelBtn.closest('[data-ws-gc]');
      if (!rootC) return;
      var taC = rootC.querySelector('[data-ws-gc-textarea]');
      if (taC) { taC.value = ''; }
      clearPendingEdit();
      setOpen(rootC, false);
      return;
    }

    // 3) Edit (remove existing line, restore the message field with prior text)
    var editBtn = e.target.closest('[data-ws-gc-edit]');
    if (editBtn) {
      e.preventDefault();
      var key = editBtn.dataset.lineKey;
      var prevMsg = editBtn.dataset.currentMessage || '';
      pendingEditMsg = prevMsg;
      try { sessionStorage.setItem('ws_gc_prev_msg', prevMsg); } catch (e) {}
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('change failed: ' + r.status);
          return r.json();
        })
        .then(function () {
          // Re-render to the offer state; the cart-event listener restores the
          // message via applyPendingEdit once the textarea is back in the DOM.
          refreshCart();
          // Backups in case the theme's own async re-render replaces the node
          // after our first restore. applyPendingEdit is idempotent and skips a
          // non-empty textarea, so these never clobber the user's typing.
          setTimeout(applyPendingEdit, 250);
          setTimeout(applyPendingEdit, 700);
          setTimeout(applyPendingEdit, 1400);
        })
        .catch(function (err) {
          console.error('[ws-gc] edit error', err);
          clearPendingEdit();
        });
      return;
    }
  });

  // Restore the in-progress edit message into the (re-rendered) offer form.
  // Idempotent and non-destructive: it does NOT clear the pending message, so if
  // the snippet is swapped again afterwards this runs once more and the final
  // render still ends up showing the text. Cleared only on save/cancel.
  function applyPendingEdit() {
    if (pendingEditMsg === null) {
      // Hydrate from sessionStorage (covers the full cart-page reload path).
      var stored = null;
      try { stored = sessionStorage.getItem('ws_gc_prev_msg'); } catch (e) {}
      if (stored === null) return;
      pendingEditMsg = stored;
    }
    var root = document.querySelector('[data-ws-gc]');
    if (!root) return;
    var ta = root.querySelector('[data-ws-gc-textarea]');
    if (!ta) return; // still in added state; a later swap will bring the textarea
    // Only fill a fresh/empty textarea — never clobber text the user is typing.
    if (ta.value && ta.value.trim() !== '') return;
    ta.value = pendingEditMsg;
    setAddMode(root, 'save');
    setOpen(root, true);
  }

  // After any cart change (including native line removal), re-render the snippet
  // from the live cart so its state stays in sync — this resets the card to the
  // offer state when the gift-card line is removed. Then restore an edit-in-progress.
  ['cart:refresh', 'cart:change', 'cart:updated'].forEach(function (evt) {
    document.addEventListener(evt, function () {
      swapSnippet().then(function () { applyPendingEdit(); });
    });
  });

  // On first load, restore an edit that survived a full cart-page reload.
  applyPendingEdit();
})();
